'use strict';

let captions = [];

function renderImageCaptions() {
  captions = [...document.querySelectorAll('.cms-image-container-rsp__caption--vertical-left, .cms-image-container-rsp__caption--vertical-right')];
  if (captions && captions.length > 0) {
    captions.forEach((caption) => {
      if (caption.style && caption.parentNode) {
        caption.style.width = caption.parentNode.offsetHeight + 'px';
      }
    });
  }
}

function init() {
  captions = [...document.querySelectorAll('.cms-image-container-rsp__caption--vertical-left, .cms-image-container-rsp__caption--vertical-right')];

  if (captions && captions.length > 0) {
    window.addEventListener('resize', renderImageCaptions);
    window.addEventListener('load', renderImageCaptions);
  }
}

init();
